// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e0d032fb","item":"_ebed69d","image":"_52225f4f","title":"_8de00268","description":"_4d103d4e","link":"_32326c68"};